import * as React from "react";
import { FaRegArrowAltCircleUp } from "react-icons/fa";
import styled from "styled-components";

import { CustomFileInput, ErrorHeader, ItemLabel, SetupButton } from "../../../../App/Common/Components/FormComponents";
import { FormContainer, Input } from "../../../pages/CourseAuthor/FormElements";
import { ImportReport } from "./ImportReport.container";
import { ImportTranslationProps } from "./ImportTranslations.types";

const UploadIcon = styled(FaRegArrowAltCircleUp)`
  margin: 0 0.5rem;
`;

const Buttons = styled.div`
  margin: 1rem 0;
  width: 22rem;
`;

export const ImportTranslationsComponent: React.FC<ImportTranslationProps> = ({ uploadCsv, uploadError }) => {
  const fileInput = React.useRef<HTMLInputElement>(null);
  const [file, changeFile] = React.useState<Nullable<File>>(null);
  const setFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files === null || files.length === 0) {
      return;
    }
    changeFile(files[0]);
  };
  const uploadFile = () => {
    if (!file) {
      return;
    }
    uploadCsv(file);
  };
  const clickRef = () => {
    fileInput.current && fileInput.current.click();
  };
  return (
    <>
      <FormContainer>
        <ItemLabel htmlFor="importTranslationsFile" />
        <Input
          accept=".csv"
          type="file"
          name="importTranslationsFile"
          onChange={setFile}
          ref={fileInput}
          style={{ display: "none" }}
        />
        <CustomFileInput onClickFunc={clickRef} file={file} />
        <Buttons>
          <SetupButton onClick={uploadFile}>
            <UploadIcon /> Upload translated csv file
          </SetupButton>
        </Buttons>
      </FormContainer>
      {uploadError && (
        <>
          <ErrorHeader>Error while importing entries: </ErrorHeader>
          {uploadError}
        </>
      )}
      <ImportReport />
    </>
  );
};
